'use client';

import React from "react";
import styles from "./BackgroundPictureAndTwoPicturesWithText.module.scss";

interface Props {
    backgroundImageUrl: string;
    leftImageUrl: string;
    rightImageUrl: string;
    title: string;
    highlightedTitle?: string;
    description?: string;
    imageTitleOne?: string;
    imageTitleTwo?: string;
}

const BackgroundPictureAndTwoPicturesWithText: React.FC<Props> = ({
    backgroundImageUrl,
    leftImageUrl,
    rightImageUrl,
    title,
    description,
    highlightedTitle,
    imageTitleOne = '',
    imageTitleTwo = '',
}) => {
    return (
        <div className={styles.relativeWrapper}>
            <section
                className={styles.wrapper}
                style={{ backgroundImage: `url(${backgroundImageUrl})` }}
            >
                <div className={styles.overlay} />

                {/* 👇 Container to limit max-width */}
                <div className={styles.container}>
                    <div className={styles.stackContainer}>
                        <figure className={styles.rightImageWrapper}>
                            <div className={styles.imageInner}>
                                <img src={rightImageUrl} alt={imageTitleOne || 'Artwork'} loading="lazy" decoding="async" />
                                <figcaption className={styles.hoverLabel}>{imageTitleOne || 'Artwork'}</figcaption>
                            </div>
                        </figure>

                        <div className={styles.textContent}>
                            <h2>
                                {highlightedTitle && (
                                    <span className={styles.highlight}>{highlightedTitle}</span>
                                )}{" "}
                                {title}
                            </h2>
                            <p>{description}</p>
                        </div>

                        <figure className={styles.leftImageWrapper}>
                            <div className={styles.imageInner}>
                                <img src={leftImageUrl} alt={imageTitleTwo || 'Artwork'} loading="lazy" decoding="async" />
                                <figcaption className={styles.hoverLabel}>{imageTitleTwo || 'Artwork'}</figcaption>
                            </div>
                        </figure>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BackgroundPictureAndTwoPicturesWithText;
